import React from 'react';
import { Box, Grid, Drawer, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { useIsMobile } from '../../../../hooks/useResponsive';
import HierarchicalLocationView from '../../../../components/LocationTree/HierarchicalLocationView';
import LocationDetailPanel from '../detail/LocationDetailPanel';
import { MOBILE_DRAWER_PAPER_SX } from '../../utils/locationConstants';

/**
 * Tree View - wraps existing HierarchicalLocationView
 * Desktop: split panel (tree left 4/12, detail right 8/12)
 * Mobile: tree full height + bottom drawer for detail
 */
const TreeView = ({
  selectedLocation,
  refreshTrigger,
  detailPanelRef,
  onLocationSelect,
  onLocationEdit,
  onLocationDelete,
  onLocationAdd,
  detailPanelProps
}) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <Box sx={{ flex: 1, overflow: 'auto' }}>
        <Box sx={{ p: 1.5 }}>
          <HierarchicalLocationView
            onLocationSelect={onLocationSelect}
            onLocationEdit={onLocationEdit}
            onLocationDelete={onLocationDelete}
            onLocationAdd={onLocationAdd}
            selectedLocationId={selectedLocation?.id || selectedLocation?._id}
            refreshTrigger={refreshTrigger}
          />
        </Box>

        {/* Mobile detail drawer */}
        {selectedLocation && (
          <Drawer
            anchor="bottom"
            open={!!selectedLocation}
            onClose={() => onLocationSelect(null)}
            PaperProps={{ sx: MOBILE_DRAWER_PAPER_SX }}
          >
            <Box sx={{ position: 'absolute', top: 8, right: 8, zIndex: 1 }}>
              <IconButton
                onClick={() => onLocationSelect(null)}
                size="small"
                aria-label="Close detail panel"
              >
                <CloseIcon />
              </IconButton>
            </Box>
            <LocationDetailPanel
              selectedLocation={selectedLocation}
              {...detailPanelProps}
            />
          </Drawer>
        )}
      </Box>
    );
  }

  // Desktop: split panel
  return (
    <Grid container sx={{
      flex: 1,
      overflow: 'hidden',
      height: 'calc(100vh - 230px)'
    }}>
      {/* Left Panel - Location Tree */}
      <Grid item xs={12} md={4} sx={{
        borderRight: 1,
        borderColor: 'divider',
        height: '100%',
        overflowY: 'auto',
        overflowX: 'hidden'
      }}>
        <Box sx={{ p: 2 }}>
          <HierarchicalLocationView
            onLocationSelect={onLocationSelect}
            onLocationEdit={onLocationEdit}
            onLocationDelete={onLocationDelete}
            onLocationAdd={onLocationAdd}
            selectedLocationId={selectedLocation?.id || selectedLocation?._id}
            refreshTrigger={refreshTrigger}
          />
        </Box>
      </Grid>

      {/* Right Panel - Location Details */}
      <Grid
        item
        xs={12}
        md={8}
        ref={detailPanelRef}
        sx={{
          height: '100%',
          overflowY: 'auto',
          overflowX: 'hidden'
        }}
      >
        <LocationDetailPanel
          selectedLocation={selectedLocation}
          {...detailPanelProps}
        />
      </Grid>
    </Grid>
  );
};

export default TreeView;
